import styled from 'styled-components';

const Picture = styled.picture`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`;

const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
`;

export { BannerImage, Picture };
